import Section from '@app/components/atoms/Section/Section'
import ImageSlider from '@app/components/ImageSlider'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import VoucherRequestedDetail from './VoucherRequestedDetail'
import VoucherRequestedInformation from './VoucherRequestedInformation'

const VoucherRequestedShow = () => {
  const {
    props: { vouchersRequested },
  } = usePage()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <ImageSlider images={vouchersRequested.images} />
            </Grid>
            <Grid item xs={8}>
              <VoucherRequestedInformation vouchersRequested={vouchersRequested} />
            </Grid>
          </Grid>
        </Section>
      </Grid>
      <VoucherRequestedDetail vouchersRequested={vouchersRequested} />
    </Grid>
  )
}

export default VoucherRequestedShow
